import React, { useEffect, useState } from 'react';
import { useUser } from '../../../../global/auth/useUser';
import { GET_USER_PAGE_INTERACTIONS } from '../../../../global/interactions/interactions-model.gql';
import { recordInteraction } from '../../../../global/interactions/recordInteraction';
import {
  GetUserPageInteractions,
  GetUserPageInteractionsVariables,
} from '../../../../global/interactions/__generated__/GetUserPageInteractions';
import { useCampfireQuery } from '../../../../global/network/useCampfireQuery';
import { useOnboardingContext } from '../../../../global/onboarding/useOnboardingContext';

const WelcomeToCampfireTutorialDialog = React.lazy(() => import('./WelcomeToCampfireTutorialDialog'));

const interaction = {
  page: 'login',
  action: 'oct-release',
};

const WelcomeDialogsInner = () => {
  const [isFirstPageVisit, setIsFirstPageVisit] = useState(false);
  const { userIdentity } = useUser();
  const { finishedOnboarding } = useOnboardingContext();

  const { postInteraction } = recordInteraction('vm');

  const { data: firstPageVisitInteractionResponse } = useCampfireQuery<
    GetUserPageInteractions,
    GetUserPageInteractionsVariables
  >(GET_USER_PAGE_INTERACTIONS, {
    options: {
      variables: {
        userId: userIdentity.userId,
        page: interaction.page,
      },
    },
  });

  useEffect(() => {
    if (firstPageVisitInteractionResponse) {
      const { userInteractions } = firstPageVisitInteractionResponse.vm;
      if (!userInteractions.find(({ action }) => action === interaction.action)) {
        setIsFirstPageVisit(true);
      }
    }
  }, [firstPageVisitInteractionResponse]);

  function handleClose() {
    postInteraction(interaction.page, interaction.action);
    setIsFirstPageVisit(false);
  }

  // Only show dialog if onboarding is complete (finishedOnboarding === true)
  // This replaces the previous check for currentOnboardingStep existence
  if (finishedOnboarding !== true) {
    return null;
  }

  return <WelcomeToCampfireTutorialDialog open={isFirstPageVisit} onClose={handleClose} />;
};

const WelcomeDialogs = () => {
  const { maybeVolunteerIdentity } = useUser();
  if (!maybeVolunteerIdentity) return null;
  return <WelcomeDialogsInner />;
};

export { WelcomeDialogs };
